import './status-dot.scss'

interface StatusDotProps {
  online: boolean
  /** Describes what this dot tracks - surfaced as tooltip and to screen readers. */
  label: string
}

/**
 * Bare colored dot for a binary liveness signal. Green = healthy. The meaning
 * is carried by the tooltip rather than visible text, so several of these can
 * sit side by side without cluttering the dashboard header.
 */
const StatusDot = ({ online, label }: StatusDotProps) => {
  return (
    <span
      className={`status-dot status-dot--${online ? 'online' : 'offline'}`}
      role='status'
      aria-live='polite'
      aria-label={label}
      title={label}
    />
  )
}

export default StatusDot
